import {
  Button,
  Grid,
} from "@mui/material";
import React, { useEffect } from "react";
import { useResponse } from "../utils/itemDataProvider";
import { useFieldArray, useForm } from "react-hook-form";
import { FormProvider, RHFFileField, RHFTextField, RHFSelectField } from "../common/hook-form";
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useReturnItemData } from "../utils/returnDataProvider";

function ReturnData({ modalData, setOpen }) {
  const { response } = useResponse();
  const { setReturnData, returnData } = useReturnItemData();
  const existingData = returnData.find(item => item.data.item.sku_id === modalData.item.sku_id);
  function capitalizeFirstLetter(word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  const rvpOptions = response && Array.isArray(response.rvpList) && response.rvpList.length > 0
    ? response.rvpList.map(val => ({
      value: val,
      label: val.split(' ').map(capitalizeFirstLetter).join(' ')
    }))
    : [];

  const unitOptions = Array.from({ length: modalData?.totalFwdUnits - modalData?.requestedReturnItems }, (_, index) => index + 1).map((val) => ({
    value: val,
    label: val
  }));


  // const methods = useForm({
  //   resolver: yupResolver(
  //     Yup.object().shape({
  //       rvpReason: Yup.string().required("RVP reason is required!"),
  //       description: Yup.string().required("Description is required!"),
  //       units: Yup.string().required("Return Units are required!"),
  //       list: Yup.array().of(
  //         Yup.object().shape({
  //           file: Yup.mixed().required('Please select image'),
  //         })
  //       ),
  //     })
  //   ),
  //   defaultValues: {
  //     rvpReason: '',
  //     description: '',
  //     units: '',
  //     list: [
  //       {
  //         file: null,
  //       },
  //     ],
  //   },
  // });


  const methods = useForm({
    defaultValues: {
      rvpReason: '',
      description: '',
      units: '',
      list: [
        {
          file: null,
        },
      ],
    },
  });


  const { handleSubmit, control, reset } = methods;
  const { fields, append, remove } = useFieldArray({
    control,
    name: "list",
  });

  const onSubmit = (data) => {
    const payload = {
      rvpReason: data.rvpReason,
      data: {
        item: {
          units: parseInt(data.units),
          sku_id: modalData?.item?.sku_id,
        },
        rvpDesc: data.description,
        skuRvpReason: data.rvpReason,
        isReturnAllowed: modalData.isReturnAllowed,
        isRequestPlaced: modalData.isRequestPlaced,
      },
      list: data?.list?.map((item) => ({
        file: item.file,
      })),
    };

    // Storing in context
    setReturnData(prevData => {
      const existingIndex = prevData.findIndex(item => item.data.item.sku_id === modalData.item.sku_id);
      if (existingIndex !== -1) {
        const updatedData = [...prevData];
        updatedData[existingIndex] = payload;
        return updatedData;
      }
      return [...prevData, payload];
    });
    setOpen(false);
    // setReload(reload => reload + 1);
  };

  // Reset the form with existing data if available
  useEffect(() => {
    if (existingData) {
      reset({
        rvpReason: existingData?.rvpReason,
        description: existingData?.data?.rvpDesc,
        units: existingData.data?.item?.units?.toString(),
        list: existingData?.list?.map(item => ({ file: item.file })),
      });
    }
  }, [existingData, reset]);

  const selectedRvpReason = methods.watch('rvpReason');
  const isOptionalImage = response?.optionalReturnImages.includes(selectedRvpReason);

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} md={6}>
          <RHFSelectField
            name="rvpReason"
            variant="filled"
            label="Return Reason *"
            width='100%'
            required={true}
            options={rvpOptions}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <RHFSelectField
            name="units"
            variant="filled"
            label="Return Units *"
            required={true}
            width='100%'
            options={unitOptions}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <RHFTextField
            label="Description"
            name="description"
            required={true}
            multiline
          />
        </Grid>
        {fields.map((field, index) => (
          <React.Fragment key={field.id}>
            <Grid container spacing={2} sx={{ mt: 1, ml: 0.6 }}>
              <Grid item xs={12} md={6}>
                <RHFFileField
                  name={`list.${index}.file`}
                  label={
                    <>
                      {`Upload Image ${index + 1} *`}
                      <span style={{ marginLeft: 10, fontSize: '0.8rem', color: 'grey' }}>
                        ( jpg, jpeg, png )
                      </span>
                    </>
                  }
                  fileType={['.jpg', '.png', 'jpeg']}
                  required={isOptionalImage ? false : true}
                />
              </Grid>
              {fields.length !== 1 && (
                <Grid item xs={4} md={1.5} sx={{ display: 'flex', alignItems: 'center' }}>
                  <Button
                    onClick={() => remove(index)}
                    color="error"
                    variant="contained"
                    startIcon={<RemoveCircleOutlineIcon />}
                    size="small"
                  >
                    Remove
                  </Button>
                </Grid>
              )}
              {fields.length === index + 1 && (
                <Grid item xs={4} md={1.5} sx={{ display: 'flex', alignItems: 'center' }}>
                  <Button
                    onClick={() =>
                      append({
                        file: null,
                      })
                    }
                    variant="contained"
                    startIcon={<AddIcon />}
                    size="small"
                  >
                    Add
                  </Button>
                </Grid>
              )}
            </Grid>
          </React.Fragment>
        ))}
        <Grid item xs={6} sx={{ ml: 0.5, mt: 2 }}>
          <Button
            type="submit"
            variant="contained"
            size="small"
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </FormProvider>
  );
}

export default ReturnData;
